import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
import CalendarReducer from "./calendar/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";
import DashboardReducer from "./dashboard/reducer"
import { apiSlice } from "../Redux/apiSlice";
import AuthReducer from '../Redux/auth/authSlice';
import CategoryReducer from '../Redux/CategorySlice';
import ProductReducer from '../Redux/ProductSlice';



const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Calendar: CalendarReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Dashboard: DashboardReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    Auth: AuthReducer,
    Category: CategoryReducer,
    Product: ProductReducer,

});



// const initializeApp = async () => {
//     await store.dispatch(
//         apiSlice.endpoints.refreshToken.initiate({}, { forceRefetch: true })
//     );
//     await store.dispatch(
//         apiSlice.endpoints.loadUser.initiate({}, { forceRefetch: true })
//     );
// };

// initializeApp();

export default rootReducer;